import { render, staticRenderFns } from "./TournamentEventEdit.vue?vue&type=template&id=00213685&scoped=true&"
import script from "./TournamentEventEdit.vue?vue&type=script&lang=js&"
export * from "./TournamentEventEdit.vue?vue&type=script&lang=js&"
import style0 from "./TournamentEventEdit.vue?vue&type=style&index=0&id=00213685&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00213685",
  null
  
)

component.options.__file = "TournamentEventEdit.vue"
export default component.exports